@if (target.type === 'StateObservationTarget' && !state && !isError) {
  <div class="statename"><fa-icon [icon]="faSyncAlt" animation="spin"></fa-icon></div>
}
@if (target.type === 'StateObservationTarget' && state) {
  @if (showIcon) {
    <fa-icon [icon]="faGlobe" class="info-icon"></fa-icon>
  }
  <div class="statename">{{getTargetLabel()}}</div>
} @else if (target.type === 'StateObservationTarget' && isError) {
  @if (showIcon) {
    <fa-icon [icon]="faGlobe" class="info-icon"></fa-icon>
  }
  <div class="statename">{{getTargetLabel()}}</div>
} @else if (target.type === 'URLObservationTarget') {
  @if (showIcon) {
    <fa-icon [icon]="faGlobe" class="info-icon"></fa-icon>
  }
  <div class="statename">{{getTargetLabel()}}</div>
} @else if (target.type === 'ContextObservationTarget') {
  @if (showIcon) {
    <fa-icon [icon]="faInfoCircle" class="info-icon"></fa-icon>
  }
  <div class="tag">{{getTargetLabel()}}</div>
} @else if (target.type === 'TagObservationTarget') {
  @if (showIcon) {
    <fa-icon [icon]="faTag"></fa-icon>
  }
  <div class="tag">{{getTargetLabel()}}</div>
  @if (target?.labels && target.labels.length > 0) {
    <wm-tags [onlyLocal]="true" [tags]="target.labels" [onlyread]="true"></wm-tags>
    <wm-tags [onlyLocal]="true" [tags]="[target.tag]" [onlyread]="true"></wm-tags>
  }
}
@if (isHovered || infoPopover.overlayVisible) {
  <div class="hovered">
    <fa-icon [icon]="faInfoCircle" (click)="infoPopover.toggle($event)"></fa-icon>
  </div>
}

<p-popover #infoPopover styleClass="wm-m-observationtarget-info-popover" [appendTo]="'body'">
  <div class="popover-content">
    <div class="type">
      <label>Type:</label>
      {{target.type}}
    </div>
    @if (target.name && target.name.length > 0) {
      <div class="name">
        <label>Name:</label>
        {{target.name}}
      </div>
    }
    @if (target.description && target.description.length > 0) {
      <div class="description">
        <label>Description:</label>
        {{target.description}}
      </div>
    }
    @if (target.labels && target.labels.length > 0) {
      <div class="labels">
        <label>Labels:</label>
        <wm-tags [onlyLocal]="true" [tags]="target.labels" [onlyread]="true"></wm-tags>
      </div>
    }
    @if (getEnvironmentSummary(); as environmentSummary) {
      <div class="environment">
        <label>Environment:</label>
        {{environmentSummary}}
      </div>
    }
    @if (target.type === 'StateObservationTarget' && state?.provenance?.path) {
      <p-button (click)="openInBrowser()">
        <fa-icon [icon]="faTv"></fa-icon>
        Open in Browser
      </p-button>
    }
  </div>
</p-popover>
